import GroupNotificationToast from '../modules/notification/GroupNotificationToast';
import PersonalNotificationToast from '../modules/notification/PersonalNotificationToast';
import SystemNotificationToast from '../modules/notification/SystemNotificationToast';

export const showNotificationToast = (message, type = 'personal') => {
  let ToastComponent;

  switch (type) {
    case 'personal':
      ToastComponent = PersonalNotificationToast;
      break;
    case 'group':
      ToastComponent = GroupNotificationToast;
      break;
    case 'system':
      ToastComponent = SystemNotificationToast;
      break;
    default:
      ToastComponent = SystemNotificationToast;
  }

  window.triggerAlert({
    children: <ToastComponent message={message} />,
    parentClassName: 'text-white',
    replacePrevious: true,
    autoHideMs: 4000,
  });
};
